(() => {
  angular.module('app').component('hostCorporatesCreateEditContact', {
    templateUrl: require('./widget.html'),
    controller: CorporateEditContactController,
    controllerAs: 'vm',
    require: {
      container: '^hostCorporatesCreateEditContainer',
    },
    bindings: {
      data: '<',
      countryCode: '<',
      billingAddress: '<',
      hasBillingAccountAddress: '<'
    },
  });

  CorporateEditContactController.$inject = [
    '$scope',
    'Hms.Employees.Employee',
    'Hms.Users.User',
    'Hms.MultiTenancy.Tenant',
  ];

  function CorporateEditContactController($scope, constsEmployee, constsUser, constsTenant) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.isDisabled = true;
    vm.isEditing = false;
    vm.isCreate = false;
    vm.constsEmployee = constsEmployee;
    vm.constsUser = constsUser;
    vm.constsTenant = constsTenant;
    vm.billingAddress = vm.billingAddress || {};

    // Held here rather than on vm.data, which while creating is the billing
    // address itself. Swapping that for an address from a billing account would
    // otherwise take the correspondence address down with it.

    vm.correspondenceAddress = {};

    // The country this widget last filled in on each address. While an address
    // still holds it, the address is following the account owner and may be
    // updated again. Any other country means the billing account or the user
    // has claimed the field, and their choice stands.

    let defaultedBillingCountry = null;
    let defaultedCorrespondenceCountry = null;

    vm.permissions = {
      create: abp.auth.isGranted('Host.Corporates.Create'),
      edit: abp.auth.isGranted('Host.Corporates.Edit'),
    };

    vm.isDirty = isDirty;
    vm.setPristine = setPristine;
    vm.validateForm = validateForm;
    vm.getPayload = getPayload;
    vm.updateBillingAddress = updateBillingAddress;
    vm.save = save;
    vm.$onChanges = changes;
    vm.$onInit = init;

    function init() {
      vm.container.addWidget(this);
    }

    function isDirty() {
      return $scope.corporateCreateEditContactForm && $scope.corporateCreateEditContactForm.$dirty;
    }

    function setPristine() {
      $scope.corporateCreateEditContactForm.$setPristine();
    }

    function updateBillingAddress(billingAddress) {
      if(vm.isCreate) {
        vm.data = billingAddress;
      }
    }

    function convertToViewModel() {
      // To convert DTO received from server for addressInput component.

      if (!vm.data) return;

      vm.correspondenceAddress = {
        street: vm.data.correspondenceStreet,
        city: vm.data.correspondenceCity,
        state: vm.data.correspondenceState,
        countrySubdivisionId: vm.data.correspondenceCountrySubdivisionId,
        postcode: vm.data.correspondencePostcode,
        countryCode: vm.data.correspondenceCountryCode,
      };
    }

    function convertToDto() {
      // To convert addressInput data model for input for server.

      if (!vm.data || !vm.correspondenceAddress) return;

      vm.data.correspondenceStreet = vm.correspondenceAddress.street;
      vm.data.correspondenceCity = vm.correspondenceAddress.city;
      vm.data.correspondenceState = vm.correspondenceAddress.state;
      vm.data.correspondencePostcode = vm.correspondenceAddress.postcode;
      vm.data.correspondenceCountryCode = vm.correspondenceAddress.countryCode;
      vm.data.correspondenceCountrySubdivisionId =
        vm.correspondenceAddress.countrySubdivisionId;
    }

    // Force validation on this form.
    // True if valid, otherwise, false.

    function validateForm(error) {
      const form = $scope.corporateCreateEditContactForm;
      App.touchFormErrors(form);

      vm.invalidDataPostcode = vm.data.postcode ? vm.invalidDataPostcode : false;

      vm.invalidCorrespondencePostcode = vm.correspondenceAddress.postcode
        ? vm.invalidCorrespondencePostcode
        : false;

      error = !(form.$valid && !vm.invalidDataPostcode && !vm.invalidCorrespondencePostcode);
    }

    // Generate the payload from this form to send to CorporateAppService API.

    function getPayload(settings) {
      convertToDto();

      _.extend(settings,  {
        contact: vm.data,
      });
    }

    // Ask container to save this widget.

    function save() {
      vm.container.saveWidget(vm);
    }

    function changes(changesObj) {
      vm.isCreate = vm.data ? !vm.data.id : false;
      updateBillingAddress(vm.billingAddress);

      // Only rebuild the correspondence view model when a new record arrives.
      // Rebuilding it on every binding change discards input the user has typed,
      // because the correspondence DTO fields it reads from are not written back
      // until convertToDto runs on save.

      if (changesObj.data) convertToViewModel();

      applyAccountOwnerCountry();
    }

    // While creating a corporate, the selected account owner's country is filled
    // in as the default country of both addresses, and keeps following the
    // account owner until something claims the field. Nothing here writes back
    // to countryCode, so neither address can change the account owner's country,
    // and the two addresses are decided independently of each other.

    function applyAccountOwnerCountry() {
      if (!vm.isCreate || !vm.countryCode) return;

      if (vm.data && !isBillingCountryClaimed()) {
        setAddressCountry(vm.data, vm.countryCode);
        defaultedBillingCountry = vm.countryCode;
      }

      if (!isCorrespondenceCountryClaimed()) {
        setAddressCountry(vm.correspondenceAddress, vm.countryCode);
        defaultedCorrespondenceCountry = vm.countryCode;
      }
    }

    // The billing account chosen on the Finance tab supplies a real address, so
    // its country wins outright. Otherwise the country is the user's own as soon
    // as it stops matching the one filled in for them.

    function isBillingCountryClaimed() {
      if (!vm.data.countryCode) return false;

      return vm.hasBillingAccountAddress || vm.data.countryCode !== defaultedBillingCountry;
    }

    function isCorrespondenceCountryClaimed() {
      if (!vm.correspondenceAddress.countryCode) return false;

      return vm.correspondenceAddress.countryCode !== defaultedCorrespondenceCountry;
    }

    // Postcode, state and city all belong to the country they were entered
    // under, so none of them survive a change of country. The address inputs
    // resync their own display through resetOnCountryChange; clearing the model
    // here keeps the saved payload right whether or not they are on screen.

    function setAddressCountry(address, countryCode) {
      if (address.countryCode === countryCode) return;

      address.countryCode = countryCode;
      address.postcode = '';
      address.state = '';
      address.city = '';
      address.subdivisionCode = '';
      address.countrySubdivisionId = '';
    }
  }
})();
